export const LEVEL = {
  level1: {
    key: 'level1',
    value: 'Level 1',
  },
  level2: {
    key: 'level2',
    value: 'Level 2',
  },
  level3: {
    key: 'level3',
    value: 'Level 3',
  }
};
